// Route constants
export const ROUTE_CONSTANTS = {
  AUTH: {
    HOME: '/',
    LOGIN: '/login',
    DASHBOARD: '/dashboard',
    FORGOT_PASSWORD: '/forgot-password',
    OTP: '/otp',
    RESET_PASSWORD: '/reset-password',
    CHANGE_PASSWORD: '/change-password',
    PAGE_NOT_FOUND: '/404',
    UNAUTHORIZED: '/401',
  },
  CATEGORY: {
    LIST: '/category',
    ADD: '/category/add',
    EDIT: '/category/edit',
    VIEW: '/category/view',
  },
  SERVICE: {
    LIST: '/service',
    ADD: '/service/add',
    EDIT: '/service/edit',
    VIEW: '/service/view',
  },
  DEPARTMENT: {
    LIST: '/department',
    ADD: '/department/add',
    EDIT: '/department/edit',
    VIEW: '/department/view',
  },
  ROLE: {
    LIST: '/role',
    ADD: '/role/add',
    EDIT: '/role/edit',
    VIEW: '/role/view',
    ASSIGN: '/assignRole',
  },
  PERMISSION: {
    LIST: '/role/permissions',
    ADD: '/role/permissions/add',
    EDIT: '/role/permissions/edit',
    VIEW: '/role/permissions/view',
  },
  TICKET: {
    LIST: '/tickets',
    ADD: '/tickets/add',
    EDIT: '/tickets/edit',
    VIEW: '/tickets/view',
    DETAIL: '/tickets/:id',
    REPORT: '/ticket-report',
  },
  CHAT: {
    LIST: '/chat',
  },
  COMPLAIN: {
    LIST: '/complain',
    ADD: '/complain/add',
    EDIT: '/complain/edit',
    VIEW: '/complain/view',
  },
  PROVIDER: {
    LIST: '/provider',
    ADD: '/provider/add',
    EDIT: '/provider/edit',
    VIEW: '/provider/view',
  },
  ACTIVITY_LOGS: {
    LIST: '/activityLogs'
  },
  CUSTOMER: {
    LIST: '/customers',
    DETAIL: '/customers/:id',
  },
  CONTACT_US: {
    LIST: '/contactUs',
  },
  ORDER_RETURN: {
    LIST: '/order-returns',
    DETAIL: '/order-returns/:id',
  },
  PROFILE: {
    PROFILE: '/profile',
    CHANGE_PASSWORD: '/change-password',
  },
};

